import React, { useState, useCallback } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { getSectionRoute } from '@services/routes.service';
import Title from '@results/containers/DesktopColumn/components/Title';
import ItemContainer from '@results/containers/DesktopColumn/components/ItemContainer';
import ItemLink from '@results/containers/DesktopColumn/components/ItemLink';
import Card from '@components/Card';
import { CLICK_LOCATION } from '@shopDetails/tracking/actions/trackSectionClicked';
import { onKeyUpFunction, onKeyDownFunction } from '@utils/a11y';
import _uniqueId from 'lodash/uniqueId';

import connect from './connect';

const Container = styled(Card)`
  padding: ${({ theme }) => theme.spacing(15)};
  margin: ${({ theme }) => theme.spacing(8, 18, 0, 18)};
`;

function ColumnMenuSection({
  sections,
  extendedMenuSectionChanged,
  isShelvesMenuLayout,
  pushPage,
  title,
  match,
  trackSectionClicked,
}) {
  const [showSections, setShowSections] = useState(true);
  const [listId] = useState(_uniqueId(title));

  const onClick = useCallback(
    (section, index) => {
      const { id, name } = section;
      trackSectionClicked({
        sectionPosition: index,
        sectionName: name,
        clickLocation: CLICK_LOCATION.DEFAULT,
      });
      if (isShelvesMenuLayout) {
        const { city, restaurant } = match?.params;
        const url = getSectionRoute({
          city,
          restaurant,
          sectionId: id,
        });
        pushPage(url);
      } else {
        extendedMenuSectionChanged(id);
      }
    },
    [
      extendedMenuSectionChanged,
      isShelvesMenuLayout,
      match,
      pushPage,
      trackSectionClicked,
    ],
  );

  return (
    <>
      {!!sections?.length && (
        <Container direction="column">
          <Title
            text={title}
            showExpandedIcon={showSections}
            onClick={() => setShowSections(!showSections)}
            ariaControls={listId}
          />

          {showSections && (
            <div aria-label={title} role="list" id={listId}>
              {sections?.map((section, index) => (
                <ItemContainer
                  role="listitem"
                  key={section.id}
                  onClick={() => onClick(section, index)}
                  onKeyUp={e =>
                    onKeyUpFunction(e, () => onClick(section, index))
                  }
                  onKeyDown={e =>
                    onKeyDownFunction(e, () => onClick(section, index))
                  }
                  tabIndex={0}
                >
                  <ItemLink>{section?.name}</ItemLink>
                </ItemContainer>
              ))}
            </div>
          )}
        </Container>
      )}
    </>
  );
}

ColumnMenuSection.propTypes = {
  // connect
  sections: PropTypes.array.isRequired,
  extendedMenuSectionChanged: PropTypes.func.isRequired,
  isShelvesMenuLayout: PropTypes.bool.isRequired,
  pushPage: PropTypes.func,
  trackSectionClicked: PropTypes.func,
  // component call
  title: PropTypes.string.isRequired,
  match: PropTypes.object,
};
export default connect(ColumnMenuSection);
